import { numberWithSpacesIntl, toFixedTruncate } from './numberWithSpaces'

export const calculateKvm = (width, height) => {
	return (width * height) / 1000000
}

export const calculateKvmWithSpaces = (width, height) => {
	return numberWithSpacesIntl((width * height) / 1000000)
}
